module.exports = __webpack_public_path__ + "static/media/netlify.c711a05b.svg";